import { useMutation } from 'react-query'
import { uploadUseCase } from '../factories'

const useUploadMultiple = () => {
  const {mutate: upload, isLoading, data, error} = useMutation(uploadUseCase.uploadMultiple)
  return {upload, isLoading, error, data}
}

export default useUploadMultiple
